export default __webpack_public_path__ + "static/inperson-995001e3aa8855b1f050520b197575b3.png";